import { T } from "@supersig/validate";
import { buildConditionalByReturnValueType } from "./conditional";
import { buildLiteral } from "./literal";
import { buildReferential } from "./referential";
import { literalValueTypes } from "../literals";
export * from "./conditional";
export * from "./literal";
export * from "./referential";
const objectWithTypeValitor = T.object({
    type: T.string
});
const literalAndReferentialValueTypeMap = {
    literal: buildLiteral(literalValueTypes),
    referential: buildReferential(literalValueTypes)
};
export const literalAndReferentialValueTypes = T.union("type", literalAndReferentialValueTypeMap);
export const automatableWithoutConditional = T.union("type", literalAndReferentialValueTypeMap);
export const automatableValueTypes = T.union("type", {
    conditional: buildConditionalByReturnValueType(T.union("type", literalAndReferentialValueTypeMap)),
    ...literalAndReferentialValueTypeMap
});
const automatableValueTypesAndDefaultPropogationNoConditional = T.union("type", {
    ...literalAndReferentialValueTypeMap,
    default: T.object({
        type: T.literal("default")
    }),
    tombstone: T.object({
        type: T.literal("tombstone")
    })
});
export const automatableValueTypesAndDefaultPropogation = T.union("type", {
    conditional: buildConditionalByReturnValueType(automatableWithoutConditional),
    ...literalAndReferentialValueTypeMap,
    // Indicates that the value should be propogated from the default value
    default: T.object({
        type: T.literal("default")
    }),
    // Indicates that the value should actually be completely niled out, overrding
    // the default value to actually be undefined
    tombstone: T.object({
        type: T.literal("tombstone")
    })
});
export const buildAutomatableValue = (value)=>{
    return T.union("type", {
        conditional: buildConditionalByReturnValueType(T.union("type", {
            literal: buildLiteral(value),
            referential: buildReferential(value)
        })),
        literal: buildLiteral(value),
        referential: buildReferential(value)
    });
};
// Builds something that could become an automatable value in the future
// even through it only allows literals right now
export const buildAutomatableValueLiteralOnly = (value)=>{
    return buildLiteral(value);
};
export * from "./Geometry2d";
export * from "./Box2d";
export * from "./Vec2d";
